


function playPause() {
    // Turn on controls for the specific video
    var myVideo = document.getElementById('main_video');
    myVideo.setAttribute("controls", "controls");
    
    // Hide the watch button
    var playBut = document.getElementsByClassName("watchButton");
    for(var i = 0; i < playBut.length; i++) {
        playBut[i].style.visibility = "hidden";
    }
    
    // Play the video
    if (myVideo.paused) {
        myVideo.play();
    }
        
    // Ensure webkit play button is visible if paused
    var css = document.createElement("style");
    css.type = "text/css";
    css.innerHTML = "#main_video::-webkit-media-controls-start-playback-button {display: block;}";
    document.body.appendChild(css);             
}
